<script lang="ts">
    import type { DisplayMessage } from "../lib/messages.svelte.ts";

    interface Props {
        msg: DisplayMessage;
    }

    let { msg }: Props = $props();
</script>

<div class="narrative-entry {msg.kind}">
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html msg.html}
</div>

<style>
    .narrative-entry {
        padding: 0.05em 0;
    }

    .narrative-entry.system {
        color: #808880;
        font-style: italic;
    }

    .narrative-entry.traceback {
        color: #c06060;
    }

    .narrative-entry.echo {
        color: #6a6050;
    }

    :global(.cmd-echo) {
        color: #6a6050;
    }

    :global(.system-msg) {
        color: #7a8878;
        font-style: italic;
    }
</style>
